import "./add.css";
import BathRoom from "./AddHelpers/Bathroom";
import BType from "./AddHelpers/BType";
import CeilingHeight from "./AddHelpers/CeilingHeight";
import District from "./AddHelpers/District";
import Property from "../../components/NewInfo/Property/Property";
import RoomsOrPropose from "./AddHelpers/RoomsOrPropose";
import BuildingStatus from "./AddHelpers/BuildingStatus";
import Otherinfo from "../../components/NewInfo/Otherinfo/Otherinfo";
import { getEstateById, getBrokers,getManagers } from "../../services/Real_estate";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useState,useEffect } from "react";
//import { useLocation } from "react-router-dom";
import { updateEstate } from "../../services/Real_estate";


const API = process.env.REACT_APP_API_URL;

export default function Add() {
  const [managers, setManagers] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [appartament, setAppartament] = useState(true);
  const [house, setHouse] = useState(false);
  const [comercial, setComercial] = useState(false);
  const [land, setLand] = useState(false);
  const [files, setFiles] = useState([]);
  const [documentFiles, setDocumentFiles] = useState([]);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [district, setDistrict] = useState(null);
  const [district1, setDistrict1] = useState(null);
  const [district2, setDistrict2] = useState(null);
  const [status, setStatus] = useState("regular");
  const [percent, setPercent] = useState("0");
  const [managerId, setManagerId] = useState("");
  const [brokerId, setBrokerId] = useState("");
  const { id, estateId } = useParams();
  const [isSold, setIsSold] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isSmall] = useState(window.innerWidth <= 1000);
  const [isSmall1] = useState(window.innerWidth <= 750);
  const [isSmall2] = useState(window.innerWidth <= 650);
  const [isSmall3] = useState(window.innerWidth <= 520);
  const [isSmall4] = useState(window.innerWidth <= 400);

const [value, setValue] = useState(editData?.sale_rent || "");
const [ownerPhones, setOwnerPhones] = useState([""]);

 console.log(estateId)
  useEffect(() => {
	  if (!estateId) return;
      getEstateById(estateId)
        .then((res) => {
      setEditData(res);
      setIsSold(res?.is_sold ?? false);
    })
        .catch(console.error);
  }, [estateId]);

useEffect(() => {
  if (editData?.sale_rent) {
    setValue(editData.sale_rent);
  }
}, [editData]);
  useEffect(() => {
    getManagers().then(setManagers).catch(console.error);
    getBrokers().then(setBrokers).catch(console.error);
  }, []);
  //const editData = location?.state.data;
  console.log(editData)
  useEffect(() => {
    console.log("USE EFFECT RUN");
    if (!editData) return;
    console.log("USE EFFECT rrrrrrrRUN");
    setManagerId(editData.manager_id || "");
    setBrokerId(editData.broker_id ?? "");
    if (editData.estate_type === "apartment") {
      setLand(false);
      setHouse(false);
      setAppartament(true);
      setComercial(false);
    } else if (editData.estate_type === "house") {
      setLand(false);
      setHouse(true);
      setAppartament(false);
      setComercial(false);
    } else if (editData.estate_type === "commercial") {
      setLand(false);
      setHouse(false);
      setAppartament(false);
      setComercial(true);
    } else if (editData.estate_type === "land") {
      setLand(true);
      setHouse(false);
      setAppartament(false);
      setComercial(false);	    
    }
  }, [editData]);
    
  
  useEffect(() => {
  if (editData?.owner_number) {
    setOwnerPhones(
      String(editData.owner_number)
        .split(",")
        .map(phone => phone.trim())
    );
  }
}, [editData]);
  const editingid =
    editData?.apartment_id ??
    editData?.house_id ??
    editData?.land_id ??
    editData?.commercial_id;
  
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files).map((file) => ({
      file,
      id: `${file.name}-${Date.now()}-${Math.random()}`, // уникальный id
      preview: URL.createObjectURL(file),
    }));

    setFiles((prev) => [...prev, ...selectedFiles]);
  };
  const handleDocumentFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files).map((file) => ({
      file,
      id: `${file.name}-${Date.now()}-${Math.random()}`, // уникальный id
      preview: URL.createObjectURL(file),
    }));

    setDocumentFiles((prev) => [...prev, ...selectedFiles]);
  };

  const addPhone = () => {
    if (ownerPhones.length < 3) {
      setOwnerPhones([...ownerPhones, ""]);
    }
  };

  const handlePhoneChange = (index, value) => {
    const updated = [...ownerPhones];
    updated[index] = value;
    setOwnerPhones(updated);
  };

  const removeFile = (id) => {
   console.log(`asjdhakjsdhjkahd${files}`)
   setFiles((prev) => prev.filter((file) => file.id !== id));
  };
  const removeDocumentFile = (id) => {
    console.log(`asjdhakjsdhjkahd${files}`);
    setDocumentFiles((prev) => prev.filter((file) => file.id !== id));
  };

  const submitData = async (e) => {
    e.preventDefault();
    const form = e.target;
    console.log("form", form);
    let newErrors = {};
    const requiredFields = [
      ...(!land ? ["sale_rent"] : []),
      "manager_id",
      "broker_id",
      "estate_name",
      "owner_name",
      "district",
      ...(!land
        ? [
            "building_type",
            "building_status",
            "rooms",
            "bathroom",
            "ceiling_height",
            "building_floor",
            "building_number",
          ]
        : []),
      ...(land ? ["propose", "land_number"] : []),
      ...(!land && !house ? ["room_number"] : []),
      ...(house ? ["land_surface"] : []),
      ...(comercial ? ["commercial_type", "c_floor"] : []),
      ...(appartament ? ["a_floor"] : []),
      ...(status === "document_exclusive" ? ["percent"]: []),
      "street",
      "surface",
      "discription",
    ];
    requiredFields.forEach((field) => {
      const fieldValue = form.elements[field]?.value || "";
      if (!fieldValue.trim()) {
        newErrors[field] = true;
      }
    });
    console.log(requiredFields)
console.log("errors", errors);
    // ✅ проверка массива телефонов
    const validPhones = ownerPhones.filter((phone) => phone.trim() !== "");

    if (validPhones.length === 0) {
      newErrors.ownerPhone = true;
    }
    

    // пример условия
    if (!land && !house && !form.room_number?.value) {
      newErrors.room_number = true;
    }

    if (Object.keys(newErrors).length > 0) {
      alert("❌ Please fill all required fields");
      setErrors(newErrors);
      return; // ❌ submit стоп
    }
    

    const createFormData = (e, ownerPhones, files, documentFiles, percent) => {
      const form = new FormData(e.target);

      // 1️⃣ Старые файлы (уже на сервере) отправляем как JSON массив
      const existingUrls = files
        .filter((f) => f.isExisting)
        .map((f) => f.preview); // preview = url на сервере
      const existingDocUrls = documentFiles
        .filter((f) => f.isExisting)
        .map((f) => f.preview);

      form.append("urls", JSON.stringify(existingUrls));
      form.append("docurls", JSON.stringify(existingDocUrls));

      console.log("Existing URLs for server:", existingUrls);
      console.log("Existing Doc URLs for server:", existingDocUrls);

      // 2️⃣ Новые файлы (только что выбранные пользователем)
      files
        .filter((f) => !f.isExisting && f.file)
        .forEach((f) => {
          form.append("files", f.file);
          console.log(
            "Added image:",
            f.file.name,
            "| size:",
            f.file.size,
            "| type:",
            f.file.type,
          );
        });

      documentFiles
        .filter((f) => !f.isExisting && f.file)
        .forEach((f) => {
          form.append("documentFiles", f.file);
          console.log(
            "Added document:",
            f.file.name,
            "| size:",
            f.file.size,
            "| type:",
            f.file.type,
          );
        });

      // 3️⃣ Owner numbers как JSON
      form.append("owner_number", JSON.stringify(ownerPhones));
      form.set("percent", percent);
      console.log("Owner numbers JSON:", JSON.stringify(ownerPhones));

      // 4️⃣ Текстовые / числовые / булевые поля
      const textFields = [
        "manager_id",
        "broker_id",
        "sale_rent",
        "aplication_status",
        "district",
        "building_type",
        "propose",
        "commercial_type",
        "building_status",
        "rooms",
        "bathroom",
        "ceiling_height",
        "street",
	"land_number",
        "building_number",
        "building_floor",
        "a_floor",
        "c_floor",
        "room_number",
        "surface",
        "land_surface",
        "price",
        "owner_name",
        "discription",
        "secret_discription",
        "status",
        "new_status",
        "estate_name",
	"is_sold",
        "individual_heating",
        "central_heating",
        "conditioner",
        "furniture",
        "equipment",
        "outdoor_balcony",
        "kitchen",
        "elevator",
        "basement",
        "attic",
        "storage_room",
        "underfloor_heating",
        "sunny_side",
        "beautiful_view",
        "park",
        "playground",
        "garage",
        "parking",
        "two_sided",
        "sweeming_pool",
        "commercial_type",
	"instagram_link",
        "rent_end_date",
	
      ];

      textFields.forEach((field) => {
  const value = form.get(field);
  if (value !== null) {
    if (field === "price" && value === "") {
      form.set(field, "-1");
    } else {
      form.set(field, value);
    }
    
  }
});

      return form;
    };

    // Использование:
    const formData = createFormData(e, ownerPhones, files, documentFiles,percent);
    let endpoint = "";
    if (land) endpoint = "/real-estate/insert_lands";
    else if (house) endpoint = "/real-estate/insert_houses";
    else if (appartament) endpoint = "/real-estate/insert_apartments";
    else if (comercial) endpoint = "/real-estate/insert_commercial";
    else alert("Please select a property type.");

    try {
      if (editData) {
        await updateEstate(editData.estate_type, editingid, formData);
          alert("✅ Successfully updated!");
        //setForRerander(true);
	  window.close();
        return;
      }
      const res = await fetch(`${API}${endpoint}`, {
        method: "POST",
        body: formData,
      });

       if (!res.ok) {
         const errorText = await res.text();
         console.error("❌ Status:", res.status);
         console.error("❌ Response:", errorText);
         alert(`Ошибка ${res.status}: ${errorText}`);
         return;
       }
       

      const result = await res.json();
      console.log("Inserted ID:", result); // house_id / apartment_id / etc
       
      // можно обновить локальный state
      //setForRerander(true);
      alert("✅ Successfully added!");
	window.close();
    } catch (err) {
      alert("❌ Server error. Please try later.");
      console.error("❌ Ошибка:", err);
    }
  };
  
	const manager = managers.find((m) => m.manager_id === id);

  console.log("this is the option",(Number(editData?.manager_id) === Number(id) || !editData));
  console.log( "this is !editdata",!editData);
  console.log( "this is editdata",editData);
  console.log("this is theee option",(Number(editData?.manager_id) === Number(id) || !editData));
  console.log("isSmall2",isSmall2);

  return (
    <form className="addestate" onSubmit={submitData}>
      <div className="titlediv">
        <div
          className="sor"
          style={{
            border: errors?.sale_rent ? "2px solid red" : "none",
            borderRadius: "10px",
            padding: "5px",
          }}
        >
          <h6>
            {isSmall1
              ? "ՀԱՅՏ. ՏԵՍ."
              : isSmall
                ? "ՀԱՅՏ. ՏԵՍԱԿ"
                : "ՀԱՅՏԱՐԱՐՈՒԹՅԱՆ ՏԵՍԱԿԸ"}
          </h6>
          <div className="upperpart">
            <div>
              <input
                type="radio"
                name="sale_rent"
                id="Sale"
                value="Sale"
                checked={value === "Sale"}
                onChange={(e) => setValue(e.target.value)}
              />
              <label htmlFor="Sale">ՎԱՃԱՌՔ</label>
            </div>

            <div>
              <input
                type="radio"
                name="sale_rent"
                id="Rent"
                value="Rent"
                checked={value === "Rent"}
                onChange={(e) => setValue(e.target.value)}
              />
              <label htmlFor="Rent">
                {isSmall1 ? "ՎԱՐՁ." : "ՎԱՐՁԱԿԱԼՈՒԹՅՈՒՆ"}
              </label>
            </div>
          </div>
        </div>
        {isSmall4 && (
          <div className="titlesmall">
            <div className="title">
              <p>
                {isSmall3 ? "ՀԱՅՏԱՐԱՐՈՒԹՅԱՆ ՎԵՐՆ." : "ՀԱՅՏԱՐԱՐՈՒԹՅԱՆ ՎԵՐՆԱԳԻՐԸ"}
              </p>
              <input
                type="text"
                name="estate_name"
                defaultValue={editData?.estate_name || ""}
                style={{
                  border: errors?.estate_name ? "2px solid red" : "none",
                  borderRadius: "10px",
                  padding: "5px",
                }}
              />
              {isSmall2 && (
                  <div className="manorbrokdiv">
                    <select
                      className="manorbrok"
                      name="manager_id"
			style={{ border: errors?.sale_rent ? "2px solid red" : "none" }}
                      value={managerId}
                      onChange={(e) => setManagerId(e.target.value)}
                    >
                      <option value="">մենեջեր</option>
                      {managers.map((manager) => (
                        <option
                          key={manager.manager_id}
                          value={manager.manager_id}
                        >
                          {manager.manager_name} {manager.manager_surname}
                        </option>
                      ))}
                    </select>
                    <select
                      className="manorbrok"
                      name="broker_id"
			style={{ border: errors?.sale_rent ? "2px solid red" : "none" }}
                      value={brokerId}
                      onChange={(e) => setBrokerId(e.target.value)}
                    >
                      <option value="">գործակալ</option>
                      {brokers.map((broker) => (
                        <option key={broker.broker_id} value={broker.broker_id}>
                          {broker.broker_name} {broker.broker_surname}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
            </div>
            <div className="neext">
              <div>
                <p>{isSmall ? "ՏԻՐՈՋ ՏՎՅԱԼ." : "ՏԻՐՈՋ ՏՎՅԱԼՆԵՐԸ"}</p>
              </div>
              <div className="owner">
                <input
                  type="text"
                  name="owner_name"
                  placeholder="Տիրոջ անունը"
                  defaultValue={editData?.owner_name || ""}
                  style={{
                    border: errors?.owner_name ? "2px solid red" : "none",
                    borderRadius: "10px",
                    padding: "3px",
                  }}
                />
                {ownerPhones.map((phone, index) => (
                  <input
                    key={index}
                    type="tel"
                    value={phone}
                    placeholder={
                      isSmall ? "Տիրոջ հեռ." : "Տիրոջ հեռախոսահամարը"
                    }
                    onChange={(e) => handlePhoneChange(index, e.target.value)}
                    style={{
                      border: errors?.ownerPhone ? "2px solid red" : "none",
                      borderRadius: "10px",
                      padding: "3px",
                    }}
                  />
                ))}
                {ownerPhones.length < 3 && (
                  <button type="button" onClick={addPhone}>
                    +
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
        {!isSmall4 && (
          <div className="title">
            <p>
              {isSmall3 ? "ՀԱՅՏԱՐԱՐՈՒԹՅԱՆ ՎԵՐՆ." : "ՀԱՅՏԱՐԱՐՈՒԹՅԱՆ ՎԵՐՆԱԳԻՐԸ"}
            </p>
            <input
              type="text"
              name="estate_name"
              defaultValue={editData?.estate_name || ""}
              style={{
                border: errors?.estate_name ? "2px solid red" : "none",
                borderRadius: "10px",
                padding: "5px",
              }}
            />
            {isSmall2 &&(
                <div className="manorbrokdiv">
                  <select
                    className="manorbrok"
                    name="manager_id"
		      style={{ border: errors?.sale_rent ? "2px solid red" : "none" }}
                    value={managerId}
                    onChange={(e) => setManagerId(e.target.value)}
                  >
                    <option value="">մենեջեր</option>
                    {managers.map((manager) => (
                      <option
                        key={manager.manager_id}
                        value={manager.manager_id}
                      >
                        {manager.manager_name} {manager.manager_surname}
                      </option>
                    ))}
                  </select>
                  <select
                    className="manorbrok"
                    name="broker_id"
		      style={{ border: errors?.sale_rent ? "2px solid red" : "none" }}
                    value={brokerId}
                    onChange={(e) => setBrokerId(e.target.value)}
                  >
                    <option value="">գործակալ</option>
                    {brokers.map((broker) => (
                      <option key={broker.broker_id} value={broker.broker_id}>
                        {broker.broker_name} {broker.broker_surname}
                      </option>
                    ))}
                  </select>
                </div>
              )}
          </div>
        )}
        {!isSmall4 && (
          <div className="neext">
            <div>
              <p>{isSmall ? "ՏԻՐՈՋ ՏՎՅԱԼ." : "ՏԻՐՈՋ ՏՎՅԱԼՆԵՐԸ"}</p>
            </div>
            <div className="owner">
              <input
                type="text"
                name="owner_name"
                placeholder="Տիրոջ անունը"
                defaultValue={editData?.owner_name || ""}
                style={{
                  border: errors?.owner_name ? "2px solid red" : "none",
                  borderRadius: "10px",
                  padding: "3px",
                }}
              />
              {ownerPhones.map((phone, index) => (
                <input
                  key={index}
                  type="tel"
                  value={phone}
                  placeholder={isSmall ? "Տիրոջ հեռ." : "Տիրոջ հեռախոսահամարը"}
                  onChange={(e) => handlePhoneChange(index, e.target.value)}
                  style={{
                    border: errors?.ownerPhone ? "2px solid red" : "none",
                    borderRadius: "10px",
                    padding: "3px",
                  }}
                />
              ))}
              {ownerPhones.length < 3 && (
                <button type="button" onClick={addPhone}>
                  +
                </button>
              )}
            </div>
          </div>
        )}
        {!isSmall2 &&(
            <div className="manorbrokdiv">
              <select
                className="manorbrok"
                name="manager_id"
		  style={{ border: errors?.sale_rent ? "2px solid red" : "none" }}
                value={managerId}
                onChange={(e) => setManagerId(e.target.value)}
              >
                <option value="">Ընտրել մենեջեր</option>
                {managers.map((manager) => (
                  <option key={manager.manager_id} value={manager.manager_id}>
                    {manager.manager_name} {manager.manager_surname}
                  </option>
                ))}
              </select>
              <select
                className="manorbrok"
                name="broker_id"
		  style={{ border: errors?.sale_rent ? "2px solid red" : "none" }}
                value={brokerId}
                onChange={(e) => setBrokerId(e.target.value)}
              >
                <option value="">Ընտրել գործակալ</option>
                {brokers.map((broker) => (
                  <option key={broker.broker_id} value={broker.broker_id}>
                    {broker.broker_name} {broker.broker_surname}
                  </option>
                ))}
              </select>
            </div>
          )}
      </div>

    <div className="rent_end_insta">  
	  {value === "Rent" && <div className="rent_end_date">
	<p>ավարտի ամսաթիվ</p>
	<input defaultValue={editData?.rent_end_date} name="rent_end_date" type="date" />
      </div>}
        <input defaultValue={editData?.instagram_link} className="insta_link" name="instagram_link" type="text" placeholder="ինստագրամի լինկ"/>
    </div>
      <div className="newinformationformstart">
        <Property
          defaultValue={editData?.estate_type}
          setLand={setLand}
          setAppartament={setAppartament}
          setHouse={setHouse}
          setComercial={setComercial}
        />
        <District
          district={district}
          district1={district1}
	  district2={district2}
          setDistrict={setDistrict}
          setDistrict1={setDistrict1}
	  setDistrict2={setDistrict2}
          defaultValue={editData?.district}
          errors={errors}
        />

        {!land && (
          <BType
            isNew={editData?.new_status}
            defaultValue={editData?.buildingtype}
            errors={errors}
          />
        )}
        {!land && (
          <BuildingStatus
            defaultValue={editData?.building_status}
            errors={errors}
          />
        )}
        <RoomsOrPropose
          defaultValue={land ? editData?.propose : editData?.rooms}
          land={land}
          errors={errors}
        />
        {!land && (
          <BathRoom defaultValue={editData?.bathroom} errors={errors} />
        )}
        {!land && (
          <CeilingHeight
            defaultValue={editData?.ceilingheight}
            errors={errors}
          />
        )}
      </div>

      <Otherinfo
        commercial={comercial}
        district={district}
        district1={district1}
	district2={district2}
        editData={editData}
        files={files}
        documentFiles={documentFiles}
        handleFileChange={handleFileChange}
        handleDocumentFileChange={handleDocumentFileChange}
        removeFile={removeFile}
        removeDocumentFile={removeDocumentFile}
        house={house}
        land={land}
        errors={errors}
        setFiles={setFiles}
        setDocumentFiles={setDocumentFiles}
	status={status}
	setStatus={setStatus}
	percent={percent}
	setPercent={setPercent}
      />
	<div>
  <input
    type="checkbox"
    id="is_sold"
    name="is_sold"
    checked={isSold}
    onChange={(e) => setIsSold(e.target.checked)}
  />
  <label htmlFor="is_sold">ՎԱՃԱՌՎԱԾ Է</label>
</div>
      <input className="formSub" type="submit" value="ՀԱՍՏԱՏԵԼ" />
    </form>
  );
}
//
